import useSpecialties from "hooks/useSpecialties";
import { useEffect, useState } from "react";
import FormAssociations from "views/admin/associations/components/FormAssociations";
import TableAssociations from "views/admin/associations/components/TableAssociations";

const Associations = () => {
  const [editData, setEditData] = useState(null);  // Estado para la especialidad que se va a editar

  const handleEdit = (dataEdit) => {
    setEditData(dataEdit);
  };

  return (
    <div className="flex items-start justify-between sm:gap-4 sm:flex-row flex-col">
      <FormAssociations editData={editData} />
      <TableAssociations onEdit={handleEdit} />
    </div>
  );
};

export default Associations;
